import React, { memo } from 'react';

import SideBarMenuComponent from './sideBarMenu';

const SideBarMenu = (props) => <div><SideBarMenuComponent {...props} /></div>;

export default SideBarMenu;
